import {
  getQueryParamValue,
  OrderByDirection,
  type Backend,
} from '@freelancer/datastore/core';
import type { CountryRequiresWhatsappCollection } from './country-requires-whatsapp.types';

export function countryRequiresWhatsappBackend(): Backend<CountryRequiresWhatsappCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: (authUid, ids, query, order) => ({
      endpoint: 'whatsapp/required.php',
      isGaf: true,
      params: {
        requestedCountry: ids?.[0] ?? getQueryParamValue(query, 'id')[0],
      },
    }),
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
